import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LayoutComponent } from './layout.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ProjectSelectorComponent } from './project-selector/project-selector.component';
import { SharedModule } from '../shared/modules/shared.module';

@NgModule({
  imports: [CommonModule, FormsModule, SharedModule],
  declarations: [
    HeaderComponent,
    FooterComponent,
    LayoutComponent,
    SidebarComponent,
    ProjectSelectorComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    LayoutComponent,
    SidebarComponent,
    ProjectSelectorComponent,
  ],
})
export class LayoutModule { }
